import {Toaster as HotToaster} from 'react-hot-toast';

export const Toaster = () => (
  <HotToaster
    containerStyle={{bottom: '12%'}}
    toastOptions={{
      style: {
        width: '100%',
        boxShadow:
          '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),0px 2px 4px rgba(0, 0, 0, 0.2)',
        borderRadius: '8px'
      }
    }}
  />
);
